export const queryService = {
  getParameter: parameter => {
    if (typeof document !== 'undefined') {
      const urlSearchParams = new URLSearchParams(document.location.search);
      return urlSearchParams.get(parameter);
    }
    return null;
  },
  updateParameters(values) {
    const url = new URL(window.location.href);
    Object.keys(values).forEach(name => {
      if (values[name]) {
        url.searchParams.set(name, values[name]);
      } else {
        url.searchParams.delete(name);
      }
    });
    window.history.replaceState({}, null, url.href);
  }
};
